import { App } from 'vue';

import { EnvironmentPropertiesInstaller as RygenEnvironmentPropertiesInstaller } from '@rygen/rygen-ui/config/EnvironmentPropertiesInstaller';
import { Environment } from '@rygen/rygen-ui/env/Environment';
import environmentPropertiesStore from '@rygen/rygen-ui/env/EnvironmentPropertiesStore';

export class EnvironmentPropertiesInstaller extends RygenEnvironmentPropertiesInstaller {
  install(app: App): void {
    super.install(app);

    // window.location.origin produces an absolute URL (e.g. http://localhost:8080
    // or https://dev.rygen.com) so Keycloak always receives a valid post-logout
    // redirect regardless of environment. Login does not set a redirect_uri so
    // keycloak-js returns the user to the page they started on.
    const appBaseUrl = `${window.location.origin}${import.meta.env.BASE_URL}`;

    environmentPropertiesStore.add(Environment.DEFAULT, {
      AZURE_LOGIN_REDIRECT_URI: `${import.meta.env.BASE_URL}auth/callback`,
      AZURE_POST_LOGOUT_REDIRECT_URI: `${import.meta.env.BASE_URL}`,
      KEYCLOAK_POST_LOGOUT_REDIRECT_URI: appBaseUrl,
    });

    environmentPropertiesStore.add(Environment.LOCAL, {
      // Local development points at the deployed dev Keycloak instance.
      // Deployed qa/demo/prod do not set KEYCLOAK_AUTH_ENABLED so the
      // AuthProviderInstaller falls back to Azure for those.
      KEYCLOAK_AUTH_ENABLED: import.meta.env.KEYCLOAK_AUTH_ENABLED ?? 'true',
      // Defaults to the deployed dev Keycloak. To run against a local docker
      // Keycloak instead, set KEYCLOAK_URL=http://localhost:7080/ in .env.local
      // (and run the backend with the keycloak spring profile).
      KEYCLOAK_URL:
        import.meta.env.KEYCLOAK_URL ??
        'https://dev.rygen.com/keycloak-corsair/',
    });

    environmentPropertiesStore.add(Environment.DEV, {
      KEYCLOAK_AUTH_ENABLED: 'true',
    });
  }
}

export const environmentProperties = new EnvironmentPropertiesInstaller();
